import { privateHttp } from '../helpers/Http';
var urlBase = process.env.REACT_APP_API_BASE_URL;
var getAll = function (data) {
    return privateHttp.post("".concat(urlBase, "/v1/search"), data);
};
var getMetrics = function (organizationId) {
    return privateHttp.post("".concat(urlBase, "/v1/search"), {
        organizationId: organizationId,
        showMetrics: true,
    });
};
var getFilters = function (_a) {
    var organizationId = _a.organizationId;
    return privateHttp.post("".concat(urlBase, "/v1/search"), {
        organizationId: organizationId,
        showMetrics: true,
    });
};
var getDocumentUrl = function (path) {
    return privateHttp.get("".concat(urlBase).concat(path));
};
var getDocumentUrlById = function (id) {
    return privateHttp.get("".concat(urlBase, "/v1/urlById/").concat(id));
};
var uploadManualMovement = function (organizationId, processId, data) {
    var formData = new FormData();
    formData.append('file', data.file[0].blobFile);
    formData.append('dtMovimentation', data.date.toLocaleDateString('pt-BR'));
    formData.append('description', data.description);
    return privateHttp.post("".concat(urlBase, "/v1/file/uploadManual/").concat(organizationId, "/process/").concat(processId), formData, {
        headers: {
            'Content-Type': "multipart/form-data; boundary=".concat(formData._boundary),
        },
    });
};
var getFilterTerms = function (organizationId) {
    return privateHttp.get("".concat(urlBase, "/v1/terms/").concat(organizationId, "/count"));
};
export var SearchService = {
    getAll: getAll,
    getMetrics: getMetrics,
    getFilters: getFilters,
    getDocumentUrl: getDocumentUrl,
    getDocumentUrlById: getDocumentUrlById,
    uploadManualMovement: uploadManualMovement,
    getFilterTerms: getFilterTerms,
};
